import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(),
    A_RefDt: new Date(),
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: "1",
    A_PayMode: "CASH",
    A_Type: "Retail",
    A_Loc: "",
    A_Buyer: "", ////SalesMan
    A_Narr: "", 
    A_DiscPerc: (0).toFixed(2),
    A_Rounding: (0).toFixed(2),
    A_DocStat: "ENTER",
    A_SalesGroup: "", //SalesGroup
    A_TaxType: "OTTRN001",
    A_CUSTFIELD9: "",
    A_Taxable: "Y",
    A_SW: "N",
    A_AMC: "N",
    A_NCND: "N",
    A_NCNDCustomer: "",
    Batch: "Batch : No",
    DO: "N",
    A_EnBy:"",
    A_ECOM:"N",
    No:"",
    A_DropShipment:"N",
    Note:"",
    LoyaltyName:"",
    LoyaltyCd:"",
    A_COD:"", 
    A_Scale: "N", 
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    SalesTerms:"",
    POBarcode:"",
    AllowOpenItem:"N",
    A_InvoiceType: "",
  },
  WmsInnContent: {},
  HeadPosMode: {
    PosMode: false,
  },
  WmsInvoiceCheckbox: {
    SalesOrder: false,
    UnitRateLC: false,
    LDisc: false,
    TDisc: false,
    Foc: false,
    Excise: false,
    TaxableAmount: true,
    
    Narration: true,
    Incentive: true,
    ItemCode:true,
    PackQty:true,
    Warranty:false
  },
};

const SliceSalesInvoice = createSlice({
  name: "SliceSalesInvoice",
  initialState: { value: initialState },

  reducers: {
    Set_SalesInvoice_Init: (state) => {
      state.value = initialState;
    },
    Set_SalesInvoice_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_Modal_Checkbox: (state, action) => {
      state.value.WmsInvoiceCheckbox = action.payload;
    },

    Set_SalesInvoice_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },

    Set_SalesInvoice_HeadObject_New: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
      state.value.HeadObject.A_TaxType = action.payload.A_TaxType;
      state.value.HeadObject.Batch = action.payload.Batch;
      state.value.HeadObject.DO = action.payload.DO;
    },
    Set_SalesInvoice_HeadObject_DrCrAccount: (state, action) => {
      state.value.HeadObject.A_CrAc = action.payload.A_CrAc;
      state.value.HeadObject.A_CrAcName = action.payload.A_CrAcName;
      state.value.HeadObject.A_DrAc = action.payload.A_DrAc;
      state.value.HeadObject.A_DrAcName = action.payload.A_DrAcName;
    },

    Set_SalesInvoice_HeadPosMode: (state, action) => {
      state.value.HeadPosMode.PosMode = action.payload.PosMode;
    },
 
    Set_SalesInvoice_HeadObject_A_VocNo_A_DocStat: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesInvoice_HeadObject_SalesGroup_SalesMan: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
    },
    Set_SalesInvoice_HeadObject_A_DocStatus: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesInvoice_HeadObject_A_Party: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Set_SalesInvoice_HeadObject_A_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
    Set_HeadObject_Type: (state, action) => {
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
  },
});

export const {
  Set_SalesInvoice_Init,
  Set_SalesInvoice_HeadObject_Init,
  Set_SalesInvoice_HeadObject_Set, 
  Set_SalesInvoice_HeadObject_New,
  Set_SalesInvoice_HeadObject_A_VocNo_A_DocStat,
  Set_SalesInvoice_HeadObject_SalesGroup_SalesMan,
  Set_SalesInvoice_HeadObject_A_DocStatus,
  Set_SalesInvoice_HeadObject_A_Party,
  Set_SalesInvoice_HeadObject_A_PayMode,
  Set_SalesInvoice_HeadPosMode,
  Set_SalesInvoice_HeadObject_DrCrAccount,
  //checkbox
  Set_Modal_Checkbox,
  Set_HeadObject_Type
} = SliceSalesInvoice.actions;
export default SliceSalesInvoice.reducer;
